import Vue from 'vue'
import App from './App'
import router from './router'
import marked from 'marked'

require('./components')

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    marked,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js